import React, { CSSProperties } from 'react';

interface ClockRotateProps {
  fill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const ClockRotate: React.FC<ClockRotateProps> = ({
  fill = 'currentColor',
  width = '100%',
  height = '100%',
  style,
  className,
}) => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 1060 1060"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
  >
    <g fill={fill}>
      <path d="M840.2,397.6c-102.5-252.7-453.9-270-593.2-57l-22.6-63.6c-4.6-13-18.9-19.8-31.9-15.2-13,4.6-19.8,18.9-15.2,31.9l41.6,117c2.2,6.3,6.8,11.4,12.8,14.2,3.4,1.6,7,2.4,10.7,2.4s5.7-.5,8.4-1.5l117.7-42c13-4.6,19.8-18.9,15.1-32-4.6-13-18.9-19.8-32-15.1l-54.8,19.6c151-211.4,524.8-108.4,519.9,172.9,5.1,295.6-408.2,394.4-541.3,137.8-4.1-7.9-12.4-12.9-21.3-12.9h-.7c-18.3,0-30,19.7-21.1,35.7,200.6,363.1,763.7,117.5,607.9-292.3Z" />
      <path d="M530,392c-13.8,0-25,11.2-25,25v138.2c0,13.8,11.2,25,25,25h99.8c13.8,0,25-11.2,25-25s-11.2-25-25-25h-74.8v-113.2c0-13.8-11.2-25-25-25Z" />
    </g>
  </svg>
);

export default ClockRotate;
